<!--
 * @Author: zhangliang
 * @Date: 2020-03-09 17:35:50
 * @LastEditTime: 2020-03-10 10:24:50
 * @LastEditors: zhangliang
 * @Description: 
 * @FilePath: \asset_app\src\views\Demo.vue
 -->
<template>
    <van-dropdown-menu>
        <van-dropdown-item :title="activeOrg.org_name" ref="dropdownOrg">
            <org-collapse :org-data="orgData" @dropdownToggle="dropdownToggle" />
        </van-dropdown-item>
    </van-dropdown-menu>
</template>
<script>
import { DropdownMenu, DropdownItem, } from 'vant';
import OrgCollapse from '../components/OrgCollapse';
import { fetch } from '../utils/http'
import store from '../store'
export default {
    components: {
        "van-dropdown-menu": DropdownMenu,
        "van-dropdown-item": DropdownItem,
        "org-collapse": OrgCollapse
    },
    computed: {
        activeOrg () {
            return store.getters.getActiveOrg
        }
    },
    data () {
        return {
            orgData: [] // 组织数据
        }
    },
    created() {
        this.getAllowOrg()
    },
    methods: {
        // 收起下拉框
        dropdownToggle() {
            this.$refs.dropdownOrg.toggle();
        },
        // 获取组织列表
        getAllowOrg() {
            fetch('/common/getAllowOrg').then(res => {
                if (res.code === 'CODE_200') {
                    this.orgData = res.data
                    setIdandActive(this.orgData)
                    let defaultActiveOrg = {
                        disabled: false,
                        id: 0,
                        isActive: true,
                        org_name: "全部领用组织"
                    }
                    store.commit('setActiveOrg', defaultActiveOrg)
                    this.orgData.unshift(defaultActiveOrg)
                } else {
                    this.$mmToast(res.msg || res.msg_arr)
                }
            })
            let setIdandActive = (orgData) => {
                orgData.id = 1
                orgData.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        setIdandActive(item.children)
                    }
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>

</style>